module.exports = __webpack_public_path__ + "img/ic_pointer.db05cdc1.svg";